import React from 'react'
import {theme} from './theme'
import {Provider} from 'mobx-react'
import {createGlobalStyle} from 'styled-components'
import {Stores} from './stores'
import {BrowserRouter, Switch, Route} from 'react-router-dom'
import PrivateRoute from './components/PrivateRoute'
import {CandidateDetailsPage} from './pages/candidate-details.page'
import {QuestionsPage} from './pages/questions.page'
import {AnswersPage} from './pages/answers.page'
import {NotFoundPage} from './pages/not.found.page'
import {FinishPage} from './pages/finish.page'
import {Notification} from './components/Notification'
import TunnusLoginPage from './pages/TunnusLoginPage/TunnusLoginPage'
import LogoutPage from './pages/LogoutPage/LogoutPage'

const GlobalStyle = createGlobalStyle`
  :root {
    font-size: 62.5%;
    body {
      margin: 0;
      padding: 0;
      font-size: 1.8rem;
      overflow-x: hidden;
    }
  }
   body,
   input,
   textarea {
      font-size: 1.8rem;
      font-family: ${theme.font.text};
   }
   h1,h2,h3,h4 {
    font-family: ${theme.font.header};
   }
   * {
    box-sizing: border-box;
   }
   ul, ol {
    list-style: none;
   }
   svg {
    fill: transparent;
   }
`

interface IProps {
  stores: Stores
}

export class VaalikoneCandidateApp extends React.Component<IProps> {
  render() {
    const baseUrl = '/ehdokas/:candidateId'
    return (
      <div>
        <Provider {...this.props.stores}>
          <BrowserRouter>
            <>
              <Notification notificationStore={this.props.stores.notificationStore} />
              <Switch>
                <Route exact path="/kirjaudu-ulos" component={LogoutPage} />
                <Route exact path="/kirjaudu/:dataString?" component={TunnusLoginPage} />
                <PrivateRoute exact path={baseUrl} component={CandidateDetailsPage} stores={this.props.stores} />
                <PrivateRoute exact path={`${baseUrl}/kysymys/:questionId`} component={QuestionsPage} stores={this.props.stores} />
                <PrivateRoute exact path={`${baseUrl}/vastaukset`} component={AnswersPage} stores={this.props.stores} />
                <PrivateRoute exact path={`${baseUrl}/kiitos`} component={FinishPage} stores={this.props.stores} />
                <Route component={NotFoundPage} />
              </Switch>
            </>
          </BrowserRouter>
        </Provider>
        <GlobalStyle />
      </div>
    )
  }
}
